import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Grid, Paper, Tab, Tabs} from "@mui/material";
import React, {useEffect, useState} from "react";
import {IContaContabil} from "@models/contaContabil/contaContabil.ts";
import {useLocation, useNavigate, useSearchParams} from "react-router";
import {GetContasContabeis} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {ContaContabilInformacao} from "@components/contaContabil/ContaContabilInformacao.tsx";
import {SolicitacoesPage} from "@components/solicitacoes/pages/solicitacoes/SolicitacoesPage.tsx";
import {ContaContabilGastosPage} from "@components/contaContabil/pages/ContaContabilGastosPage.tsx";
import {ContaContabilRecursoLimitePage} from "@components/contaContabil/pages/ContaContabilRecursoLimitePage.tsx";
import {
    CcDistribuivelSelectionPage
} from "@components/contaContabil/valoresDistribuiveis/pages/CcDistribuivelSelectionPage.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface ContaContabilPageProps extends DefaultPageProps {

}

type tabs = 'Informacoes' | 'Solicitacoes' | 'Gastos' | 'Recursos' | 'Valores'


export function ContaContabilPage(props: ContaContabilPageProps) {
    const {Get} = useApi()

    const [contaContabil, setContaContabil] = useState<IContaContabil | null>(null);
    const [searchParams] = useSearchParams()
    const [tab, setTab] = React.useState<tabs>('Informacoes')

    const location = useLocation()
    const navigate = useNavigate()

    const [contaContabilId] = useState(searchParams.get('contaContabilId'))

    useEffect(() => {
        setTab(location.hash.slice(1) as tabs || 'Informacoes')
    }, [location.hash]);

    useEffect(() => {
        if (!contaContabilId) return

        Get(GetContasContabeis({idContaContabil: [Number(contaContabilId)]}, {page: 1, pageSize: 1})).then(x => {
            if (x.status == 'Success') {
                setContaContabil(x.items[0])
            }
        })

    }, [contaContabilId]);

    return (
        <DefaultContainer titulo={props.hideHeader ? '' : 'Conta Contabil'} component={Paper}>
            {contaContabil && <Grid>

                <ContaContabilInformacao value={contaContabil} variant={'list'}/>
                <Tabs value={tab} onChange={(_e, v) => {
                    navigate({
                        pathname: location.pathname,
                        search: location.search,
                        hash: v
                    })
                }}>
                    <Tab value={'Informacoes'} label={'Informações'}/>
                    <Tab value={'Solicitacoes'} label={'Solicitações'}/>
                    <Tab value={'Gastos'} label={'Gastos'}/>
                    <Tab value={'Recursos'} label={'Recursos'}/>
                    <Tab value={'Valores'} label={'Valores'}/>
                </Tabs>
                {tab == 'Informacoes' && <ContaContabilInformacao value={contaContabil} variant={'grid'}/>}
                {tab == 'Solicitacoes' && <SolicitacoesPage filtros={{contaContabilId: [contaContabil.id]}}/>}
                {tab == 'Gastos' && <ContaContabilGastosPage contaContabilId={[contaContabil.id]} hideHeader={true}/>}
                {tab == 'Recursos' && <ContaContabilRecursoLimitePage hideHeader contaContabilId={contaContabil.id}/>}
                {tab == 'Valores' && <CcDistribuivelSelectionPage preset={{contaContabil: contaContabil.id}}
                                                                  filtros={{contaContabilId: [contaContabil.id]}}
                                                                  hideHeader={true}/>}

            </Grid>}
        </DefaultContainer>
    )
}